module.exports = __webpack_public_path__ + "static/img/only-text-sistesi.bd30e2dc.svg";